import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
// Translation files
import deDE from './de-DE.json';
import enAU from './en-AU.json';
import enCA from './en-CA.json';
import enGB from './en-GB.json';
import enIE from './en-IE.json';
import enUS from './en-US.json';
import esES from './es-ES.json';
import esMX from './es-MX.json';
import frCA from './fr-CA.json';
import frFR from './fr-FR.json';
import itIT from './it-IT.json';
import jaJP from './ja-JP.json';
import koKR from './ko-KR.json';
import ptBR from './pt-BR.json';
import zhCN from './zh-CN.json';
// We declare our translations
const resources = {
    'de-DE': {
        translation: deDE, // German (Germany)
    },
    'en-AU': {
        translation: enAU, // English (Australia)
    },
    'en-CA': {
        translation: enCA, // English (Canada)
    },
    'en-GB': {
        translation: enGB, // English (United Kingdom)
    },
    'en-IE': {
        translation: enIE, // English (Ireland)
    },
    'en-US': {
        translation: enUS, // English (United States)
    },
    'es-ES': {
        translation: esES, // Spanish (Spain)
    },
    'es-MX': {
        translation: esMX, // Spanish (Mexico)
    },
    'fr-CA': {
        translation: frCA, // French (Canada)
    },
    'fr-FR': {
        translation: frFR, // French (France)
    },
    'it-IT': {
        translation: itIT, // Italian (Italy)
    },
    'ja-JP': {
        translation: jaJP, // Japanese (Japan)
    },
    'ko-KR': {
        translation: koKR, // Korean (Korea)
    },
    'pt-BR': {
        translation: ptBR, // Portuguese (Brazil)
    },
    'zh-CN': {
        translation: zhCN, // Chinese (Simplified)
    },
};
export const i18nInstance = i18n.createInstance();
const i18nInit = (locale = 'en-US') => i18nInstance
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
    resources,
    lng: locale,
    fallbackLng: 'en-US',
    keySeparator: false,
    nsSeparator: false,
    interpolation: {
        escapeValue: false, // react already safes from xss
    },
    react: {
        transKeepBasicHtmlNodesFor: [],
    },
});
export default i18nInit;
//# sourceMappingURL=index.js.map